import React from 'react';
import NewsIconWrapper from './NewsIconWrapper';

export default function OfferRestart(props) {
  return (
    <NewsIconWrapper {...props}>
      <circle cx="16" cy="16" r="16" fill="#6FCF97" fillOpacity="0.4"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M16 6C10.48 6 6 10.48 6 16C6 21.52 10.48 26 16 26C21.52 26 26 21.52 26 16C26 10.48 21.52 6 16 6ZM14 20.5L20 16L14 11.5V20.5ZM8 16C8 20.41 11.59 24 16 24C20.41 24 24 20.41 24 16C24 11.59 20.41 8 16 8C11.59 8 8 11.59 8 16Z" fill="black" fillOpacity="0.54"/>
    </NewsIconWrapper>
  );
}
